export default __webpack_public_path__ + "static/media/02.cc42c20d.jpg";